import { NameDto } from '../../Common/Types'

export interface TransactionAdjustmentUploadHistory {
  dateCreated: string
  dateFinished: string | null
  fileName: string
  details: UploadHistoryTransactionDetails[]
  id: string
}

export interface UploadHistoryTransactionDetails {
  directionType: NameDto
  id: string
  lineNumber: 1
  masterTransaction: {
    id: string
    referenceId: string
    type: NameDto
    state: NameDto
    creditAmount: string
    debitAmount: string
  }
  recordData: {
    Amount: number
    Client: string
    Company: string
    CreditAccount: string
    Currency: string
    DebitAccount: string
    PaymentType: string
  }
  result: null
  status: NameDto
  tradingAccount: {
    id: string
    name: string
  }
  uploadFileHistory: {
    id: string
    name: string
  }
}

export enum TransactionAdjustmentUploadHistoryKey {
  lineNumber = 'lineNumber',
  record = 'recordData.Amount',
  directionType = 'directionType.name',
  tradingAccount = 'tradingAccount.name',
  transaction = 'masterTransaction.referenceId',
  status = 'status.name',
  result = 'result',

  wallet = 'wallet.name',
}
